import React from 'react';
import PropTypes from 'prop-types';
import Edit from './rowActions/Edit';
import { Box } from '@mui/material';

const RowActions = ({ rowData, setDetailCallbackComponent }) => <Box>
  <Edit rowData = {rowData} setDetailCallbackComponent = {setDetailCallbackComponent}/>
</Box>;


RowActions.propTypes = {
  row: PropTypes.object.isRequired,
  setDetailCallbackComponent: PropTypes.func
};


export default RowActions;
